import { ComponentPropsWithoutRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@givebutter/primitives/button';
import { Label } from '@givebutter/primitives/label';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import * as Form from 'components/form';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

interface LetterDetailsRowProps extends ComponentPropsWithoutRef<'div'> {
    label: string;
    path?: string;
    hideEditButton?: boolean;
}
const LetterDetailsRow = (props: LetterDetailsRowProps) => {
    const { label, path, hideEditButton = false, className = '', children, ...rest } = props;
    const history = useHistory();
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();

    return (
        <div className={`flex items-center justify-between ${className}`} {...rest}>
            <Form.Container>
                <Label>{label}</Label>
                {children}
            </Form.Container>
            {!hideEditButton && (
                <Button
                    variant="none"
                    color="primary"
                    size="sm"
                    className="font-medium"
                    onClick={() =>
                        history.push(
                            path ??
                                `/accounts/${accountId}/engage/letters/draft/${letter?.id}/edit/details`,
                        )
                    }
                >
                    Edit
                </Button>
            )}
        </div>
    );
};

export { LetterDetailsRow };
export type { LetterDetailsRowProps };
